import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { shared } from "../styles.js";

/**
 * tag-badge renders a tag pointer as a chip (R17/S7). A `managed` tag (the
 * system-managed `latest`) shows a lock and is read-only — it carries no move
 * control. Tag management (moving non-`latest` tags, deprecate/yank) lives in the
 * page-package maintainer panel, which owns the version list and the API calls.
 */
@customElement("tag-badge")
export class TagBadge extends LitElement {
  static override styles = [
    shared,
    css`
      .lock {
        color: var(--muted);
      }
    `,
  ];

  @property() name = "";
  @property({ type: Boolean }) managed = false;

  override render() {
    return html`<span
      class="chip"
      title=${this.managed ? "system-managed tag (read-only)" : `tag: ${this.name}`}
    >
      ${this.name}${this.managed ? html` <span class="lock" aria-label="system-managed">🔒</span>` : ""}
    </span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "tag-badge": TagBadge;
  }
}
